import React, { useCallback, useMemo } from 'react';

const ProjectRow = React.memo(
  ({ project, index, projectsLength, handleProjectChange, removeProject }) => (
    <div
      className="project-row"
      style={{
        marginBottom: "15px",
        padding: "15px",
        border: "1px solid #ddd",
        borderRadius: "5px",
      }}
    >
      <div
        className="project-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <h4>Project {index + 1}</h4>
        {projectsLength > 1 && (
          <button
            type="button"
            onClick={() => removeProject(index)}
            className="remove-btn"
            style={{
              background: "red",
              color: "white",
              border: "none",
              padding: "5px 10px",
              borderRadius: "3px",
              cursor: "pointer",
              fontFamily: "'Times New Roman', Times, serif",
            }}
          >
            Remove
          </button>
        )}
      </div>

      <div className="form-row">
        <div className="form-group">
          <label className="label">Project Title</label>
          <input
            type="text"
            value={project.projectTitle || ""}
            onChange={(e) =>
              handleProjectChange(index, "projectTitle", e.target.value)
            }
            className="input"
            placeholder="Enter project title"
          />
        </div>

        <div className="form-group">
          <label className="label">Project Status</label>
          <select
            value={project.projectStatus || ""}
            onChange={(e) =>
              handleProjectChange(index, "projectStatus", e.target.value)
            }
            className="input select"
          >
            <option value="">Select Status</option>
            <option value="Not Started">Not Started</option>
            <option value="In Progress">In Progress</option>
            <option value="Completed">Completed</option>
            <option value="On Hold">On Hold</option>
            <option value="Cancelled">Cancelled</option>
          </select>
        </div>
      </div>

      {/* ⭐ Project Score */}
      <div className="form-row">
        <div className="form-group">
          <label className="label">Project Score</label>
          <div className="star-rating">
            {[...Array(10)].map((_, starIndex) => {
              const value = starIndex + 1;
              return (
                <span
                  key={value}
                  className={`star ${
                    value <= (project.projectScore || 0) ? "filled" : ""
                  }`}
                  onClick={() =>
                    handleProjectChange(index, "projectScore", value)
                  }
                  style={{ cursor: "pointer" }}
                >
                  ★
                </span>
              );
            })}
          </div>
        </div>
      </div>

      {/* 📝 Project Feedback (Mandatory only if score > 0) */}
      <div className="form-row">
        <div className="form-group">
          <label className="label">
            Project Feedback{" "}
            {project.projectScore > 0 && (
              <span style={{ color: "red" }}>*</span>
            )}
          </label>

          <textarea
            value={project.projectFeedback || ""}
            onChange={(e) =>
              handleProjectChange(index, "projectFeedback", e.target.value)
            }
            className="input"
            placeholder="Write feedback..."
            style={{
              border:
                project.projectScore > 0 && !project.projectFeedback
                  ? "1px solid red"
                  : "1px solid #ccc",
              height: "80px",
            }}
          />

          {/* Error message */}
          {project.projectScore > 0 && !project.projectFeedback && (
            <p style={{ color: "red", marginTop: "5px" }}>
              Feedback is required when score is given.
            </p>
          )}
        </div>
      </div>
    </div>
  )
);

const ProjectsSection = ({ formData, onProjectsChange, isExpanded = true }) => {
  const projects = useMemo(() => {
    return formData.projects && formData.projects.length > 0
      ? formData.projects
      : [
          {
            projectTitle: "",
            projectStatus: "",
            projectScore: 0,
            projectFeedback: "",
          },
        ];
  }, [formData.projects]);

  const handleProjectChange = useCallback(
    (index, field, value) => {
      const updatedProjects = [...projects];
      updatedProjects[index] = {
        ...updatedProjects[index],
        [field]: value,
      };
      onProjectsChange(updatedProjects);
    },
    [projects, onProjectsChange]
  );

  const addProject = useCallback(() => {
    if (projects.length < 3) {
      const newProjects = [
        ...projects,
        {
          projectTitle: "",
          projectStatus: "",
          projectScore: 0,
          projectFeedback: "",
        },
      ];
      onProjectsChange(newProjects);
    }
  }, [projects, onProjectsChange]);

  const removeProject = useCallback(
    (index) => {
      if (projects.length > 1) {
        const updatedProjects = projects.filter((_, i) => i !== index);
        onProjectsChange(updatedProjects);
      }
    },
    [projects, onProjectsChange]
  );

  return (
    <div className="form-section">
      {isExpanded && (
        <div className="section-content">
          {projects.map((project, index) => (
            <ProjectRow
              key={index}
              project={project}
              index={index}
              projectsLength={projects.length}
              handleProjectChange={handleProjectChange}
              removeProject={removeProject}
            />
          ))}

          {projects.length < 3 && (
            <div className="form-row">
              <button
                type="button"
                onClick={addProject}
                className="add-project-btn"
                style={{
                  background: "#007bff",
                  color: "white",
                  border: "none",
                  padding: "10px 15px",
                  borderRadius: "5px",
                  width: "30%",
                  cursor: "pointer",
                  marginTop: "10px",
                  fontFamily: "'Times New Roman', Times, serif",
                }}
              >
                + Add Project
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProjectsSection;
